<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">Calendario settimanale di default</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-2"
            @click="dialog_conferma_salva = true"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-2"
            @click="aggiungiRighe"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Aggiungi righe</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickIndietro" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text style="overflow-y: auto">
      <v-form>
        <v-container>
          <v-row v-for="(item, i) in righe" :key="i" align="center">
            <v-col class="py-0" cols="2">
              <v-autocomplete
                v-model="item.giorno_ini"
                :items="giorni"
                item-text="Giorno_partenza"
                label="Dal giorno"
                required
                item-value="giorno_iniziale"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="py-0" cols="2">
              <v-autocomplete
                v-model="item.giorno_fine"
                :items="giorni"
                item-text="Giorno_fine"
                label="al giorno"
                required
                item-value="giorno_finale"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="py-0" cols="2">
              <v-checkbox
                color="primary"
                v-model="item.giorno_intero"
                :label="'Giorno intero'"
              ></v-checkbox>
            </v-col>
            <v-col v-if="!item.giorno_intero" class="py-0" cols="2">
              <v-autocomplete
                v-model="item.ora_ini"
                :items="ore"
                item-text="Ora_partenza"
                label="Dalle ore"
                required
                item-value="ora_iniziale"
              >
              </v-autocomplete>
            </v-col>
            <v-col v-if="!item.giorno_intero" class="py-0" cols="2">
              <v-autocomplete
                v-model="item.ora_fine"
                :items="ore"
                item-text="Ora_fine"
                label="alle ore"
                required
                item-value="ora_finale"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="py-0" cols="2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="eliminaRiga(i)" small v-bind="attrs" v-on="on">
                    <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Cancella</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>

    <v-overlay
      color="rgba(0, 0, 0, 1)"
      style="position: absolute"
      :value="caricamento_dati"
    >
      <v-icon class="ConsuntivoWORuota" size="100">mdi-cog</v-icon>
      <v-icon class="ConsuntivoWOControruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
    <!-- DIALOG CONFERMA SALVATAGGIO -->
    <v-dialog v-model="dialog_conferma_salva" width="unset">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Salva</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salva" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_conferma_salva = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-0">
          <h3 class="mt-5">
            Clicca salva per schedulare le commesse selezionate.
          </h3>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Riga {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "giorno_ini", default_val: 1 },
      { nome: "giorno_fine", default_val: 5 },
      { nome: "giorno_intero", default_val: true },
      { nome: "ora_ini", default_val: 0 },
      { nome: "ora_fine", default_val: 24 },
    ];

    return campi;
  }
}
export default {
  name: "",
  components: { SnackbarQV },
 
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      caricamento_dati: false,
      giorni: [1, 2, 3, 4, 5, 6, 7],
      ore: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20, 21, 22, 23, 24,
      ],
      dialog_conferma_salva: false,
      dialog_conferma_elimina: false,
      id_eliminazione: "",
      fasi_commessa: [],
      righe: [new Riga()],

      // Array
      headers: [],
      work_orders: new Array(),
      work_orders_totali: new Array(),
    };
  },
  computed: {},
  watch: {
 
  },

  methods: {
    aggiungiRighe() {
      this.righe.push(new Riga());
    },

    clickIndietro() {
      this.$emit("click_chiudi");
    },

    eliminaRiga(i) {
      this.righe.splice(i, 1);
    },

    salva() {
      const arr_tmp = new Array();
      this.items.forEach((w) => {
        if (w.selezionato === true) {
          let commessa = {
            id_commessa: w.id_commessa,
            colore_testo: w.colore_testo,
            colore_sfondo: w.colore_sfondo,
          };
          arr_tmp.push(commessa);
        }
      });

      const request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "schedulazione",
          token: localStorage.user_token,
          commesse: arr_tmp,
        },
      };

      // Inserisco un overlay di caricamento.
      (this.dialog_conferma_salva = false), (this.caricamento_dati = true);

      this.$store
        .dispatch("api", request)
        .then((res) => {
          // Tolgo l'overlay di caricamento.
          this.caricamento_dati = false;

          if (res.status === 200) {
            this.$emit("inviati_wo");

            // Stampo una snackbar di conferma.
            this.$refs.SnackbarQV.print(
              "success",
              "Fasi commessa avanzate con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          // Tolgo l'overlay di caricamento.
          this.caricamento_dati = false;

          // Stampo una snackbar di avviso.
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );

          // Stampo il log dell'errore in console.
          console.error(err);
        });
    },
  },

  created() {},
  mounted() {},
};
</script>
<style scoped>
@keyframes ConsuntivoWOControtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes ConsuntivoWORotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ConsuntivoWOControruota {
  animation: ConsuntivoWOControtazione 1s infinite;
  animation-timing-function: linear;
}

.ConsuntivoWORuota {
  animation: ConsuntivoWORotazione 1s infinite;
  animation-timing-function: linear;
}
</style>